import { render, staticRenderFns } from "./techrequirements.vue?vue&type=template&id=da3cf110&"
import script from "./techrequirements.vue?vue&type=script&lang=js&"
export * from "./techrequirements.vue?vue&type=script&lang=js&"
import style0 from "./techrequirements.vue?vue&type=style&index=0&id=da3cf110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports